import { render } from "./RoleView.vue?vue&type=template&id=a894a92e&scoped=true"
import script from "./RoleView.vue?vue&type=script&lang=js"
export * from "./RoleView.vue?vue&type=script&lang=js"

import "./RoleView.vue?vue&type=style&index=0&id=a894a92e&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a894a92e"]])

export default __exports__